module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/recovery_user_privacy_19.png";